import { render } from "./Calender.vue?vue&type=template&id=00036500&scoped=true"
import script from "./Calender.vue?vue&type=script&lang=js"
export * from "./Calender.vue?vue&type=script&lang=js"

import "./Calender.vue?vue&type=style&index=0&id=00036500&scoped=true&lang=css"

import exportComponent from "/Users/chencheng/code/bethlehem/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00036500"]])

export default __exports__